/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';

export interface AppsControllerFindOne$Params {

/**
 * The app id
 */
  id: string;
}

export function appsControllerFindOne(http: HttpClient, rootUrl: string, params: AppsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appsControllerFindOne.PATH = '/apps/{id}';
